import { ReactComponent as EmptyList } from "../../../../src/media/basket.svg";
import DateModal from "./DateModal";
import TopNavbar from "../../../components/TopNavbar";
import { useState } from "react";

const EmptyGrocery = ({ caption, setRand }) => {
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [emptyDate1Error, setEmptyDate1Error] = useState("");
  const [emptyDate2Error, setEmptyDate2Error] = useState("");

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEmptyDate1Error(false);
    setEmptyDate2Error(false);    
  };
  return (
    <>
      <TopNavbar
        title="لیست خرید"
        rbuttonIcon={[""]}
        rbuttonHref={["null"]}
        rbackground={["bTransparent"]}
        lbuttonIcon={[""]}
        lbuttonHref={["null"]}
        lbackground={["bTransparent"]}
      />
      <div className="">
        <EmptyList className="radius2" alt="empty"></EmptyList>
        <h5 className="subject-1 yekan">{caption}</h5>
        <div className="marginBottom5 marginSide10">
          <button onClick={handleOpenModal} className="subject-1">
          + اضافه کردن لیست خرید از تقویم
          </button>
        </div>
      </div>

      <DateModal
      showModal={showModal}
      handleCloseModal={handleCloseModal}
      loading={loading}
      emptyDate1Error={emptyDate1Error}
      emptyDate2Error={emptyDate2Error}
      setRand={setRand}
      ></DateModal>




    </>
  );
};
export default EmptyGrocery;
